module.exports = __webpack_public_path__ + "static/media/4C.037d8c23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4C.svg
// module id = 61
// module chunks = 0